import { Box, Grid2, Stack, Typography } from '@mui/material';

import { Icon } from '@iconify/react';

import MeasureLengths from 'assets/images/help/measurements/measure-lengths.png'
import AddMeasurement from 'assets/images/help/measurements/add-measurement.png'
import AddReferenceMeasurement from 'assets/images/help/measurements/add-reference-measurement.png'
import DeleteMeasurement from 'assets/images/help/measurements/delete-measurement.png'

const measurementsSections = [
  {
    id: "Measure Lengths",
    title: "Measure Lengths",
    description: "Click the Measure tool, then select two points in your scene to instantly see the distance between them.",
    icon: 'jam:set-square',
    image: MeasureLengths,
  },
  {
    id: "Add Measurement",
    title: "Add Measurement",
    description: "Enter the actual length between selected points to scale the scene for precise measurements throughout.",
    icon: 'ph:pencil-ruler-duotone',
    image: AddMeasurement,
  },
  {
    id: "Add a Reference Measurement",
    title: "Add a Reference Measurement",
    description: "To ensure high accuracy, click Set Reference, then select two known points to calibrate the scene.",
    icon: 'ph:cursor-click',
    image: AddReferenceMeasurement,
  },
  {
    id: "Delete a Measurement",
    title: "Delete a Measurement",
    description: "Need to reset? Tap the delete icon, select the measurement you want to remove.",
    icon: 'solar:trash-bin-trash-linear',
    image: DeleteMeasurement,
  },
]

const MeasurementsPage = () => {
  return (
    <Grid2 container justifyContent="center" alignItems="center" columnGap={6} rowGap={4}>
      {/* <Grid2 container spacing={1.5}> */}
        {measurementsSections.map((section) => (
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} alignItems="center" key={section.id}>
                <img 
                  src={section.image} 
                  alt={section.title} 
                  style={{ 
                    // width: '100%', 
                    // height: '100%',
                    maxHeight: '10rem',
                    objectFit: 'cover',
                    aspectRatio: '16/9',
                                          borderRadius: '8px'
                  }} 
                />
              <Stack spacing={1} sx={{
                
              }}>
                  <Icon
                    icon={section.icon} 
                    style={{ 
                      width: '1.5rem', 
                      height: '1.5rem',
                      marginBottom: ".5rem",
                    }} 
                  />
                <Typography variant="subtitle1" sx={{ fontWeight: 'medium', fontSize: '.875rem' }}>
                  {section.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '.75rem', maxWidth: '18rem', textWrap: 'balance' }}>
                  {section.description}
                </Typography>
              </Stack>
          </Stack>
        ))}
      {/* </Grid2> */}
    </Grid2>
  )
}

export default MeasurementsPage